import { frontConstants } from "../constants/frontConstants";
import { frontService } from "../../services/API/frontService";
import { alertActions } from "./alert.actions";
import { history } from "../store/configureStore";
import Alert from "../../components/alert/Alert";
import isEmpty from "lodash.isempty";

export const contractActions = {};

export const affiliateWidget = (permalink) => {
  return (dispatch) => {
    frontService.affiliateWidget(permalink).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_WIDGET_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_WIDGET_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_WIDGET_FAILURE, error };
  }
};
export const getDealList = (postData) => {
  return (dispatch) => {
    frontService.getDealList(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_ALLDEAL_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_ALLDEAL_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_ALLDEAL_FAILURE, error };
  }
};

export const getMenuList = (postData) => {
  return (dispatch) => {
    frontService.getMenuList(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_MENU_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_MENU_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_MENU_FAILURE, error };
  }
};

export const topDeals = (postData) => {
  return (dispatch) => {
    frontService.topDeals(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_TOPDEAL_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_TOPDEAL_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_TOPDEAL_FAILURE, error };
  }
};

export const currentDealList = (postData) => {
  return (dispatch) => {
    frontService.currentDealList(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_CURRENTDEAL_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_CURRENTDEAL_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_CURRENTDEAL_FAILURE, error };
  }
};

export const merchantDirectoryList = (postData) => {
  return (dispatch) => {
    frontService.merchantDirectoryList(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_MERCHANTDIRECTORYLIST_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_MERCHANTDIRECTORYLIST_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_MERCHANTDIRECTORYLIST_FAILURE, error };
  }
};

export const upcomingDealList = (postData) => {
  return (dispatch) => {
    frontService.upcomingDealList(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_UPCOMINGDEAL_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_UPCOMINGDEAL_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_UPCOMINGDEAL_FAILURE, error };
  }
};

export const dealDetail = (postData) => {
  return (dispatch) => {
    frontService.dealDetail(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_DEALDETAIL_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_DEALDETAIL_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_DEALDETAIL_FAILURE, error };
  }
};

export const addToCart = (postData) => {
  return (dispatch) => {
    frontService.addToCart(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_ADDTOCART_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_ADDTOCART_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_ADDTOCART_FAILURE, error };
  }
};

export const CheckUserKey = (postData) => {
  return (dispatch) => {
    frontService.CheckUserKey(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_CHECKUSERKEY_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_CHECKUSERKEY_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_CHECKUSERKEY_FAILURE, error };
  }
};

export const getCartDetail = (postData) => {
  return (dispatch) => {
    frontService.getCartDetail(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_CARTDETAIL_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_CARTDETAIL_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_CARTDETAIL_FAILURE, error };
  }
};

export const getQuantityCart = (postData) => {
  return (dispatch) => {
    frontService.getQuantityCart(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_CARTQUANTITY_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_CARTQUANTITY_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_CARTQUANTITY_FAILURE, error };
  }
};

export const updateCart = (postData) => {
  return (dispatch) => {
    frontService.updateCart(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_CARTUPDATE_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_CARTUPDATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_CARTUPDATE_FAILURE, error };
  }
};

export const removeItem = (cartID) => {
  return (dispatch) => {
    frontService.removeItem(cartID).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_REMOVEITEM_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_REMOVEITEM_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_REMOVEITEM_FAILURE, error };
  }
};

export const checkout = (postData, url) => {
  return (dispatch) => {
    dispatch(request());
    frontService.checkout(postData, url).then(
      (data) => {
        dispatch(success(data));
      },

      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_CHECKOUT_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_CHECKOUT_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_CHECKOUT_FAILURE, error };
  }
};

export const register = (postData) => {
  return (dispatch) => {
    frontService.register(postData).then(
      (data) => {
        dispatch(success(data));
        if (localStorage.getItem("userTypeName") == "customer") {
          history.push("/");
        } else {
          history.push("/dashboard");
        }
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_REGISTER_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_REGISTER_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_REGISTER_FAILURE, error };
  }
};

export const applyPromoCode = (postData) => {
  return (dispatch) => {
    frontService.applyPromoCode(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_APPLYPROMO_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_APPLYPROMO_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_APPLYPROMO_FAILURE, error };
  }
};

export const userLogout = () => {
  return (dispatch) => {
    frontService.userLogout().then(
      (data) => {
        dispatch(success(data));
        history.push("/login");
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.LOGOUT_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.LOGOUT_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.LOGOUT_FAILURE, error };
  }
};

export const userVoucherList = (formData) => {
  return (dispatch) => {
    frontService.userVoucherList(formData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_VOUCHERLIST_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_VOUCHERLIST_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_VOUCHERLIST_FAILURE, error };
  }
};

export const userVoucherListArchive = (formData) => {
  return (dispatch) => {
    frontService.userVoucherListArchive(formData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_VOUCHERLISTARCHIVE_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_VOUCHERLISTARCHIVE_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_VOUCHERLISTARCHIVE_FAILURE, error };
  }
};

export const userOrderList = (formData) => {
  return (dispatch) => {
    frontService.userOrderList(formData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_ORDERLIST_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_ORDERLIST_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_ORDERLIST_FAILURE, error };
  }
};

export const customerDetail = (user_id) => {
  return (dispatch) => {
    frontService.customerDetail(user_id).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_CUSTOMER_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_CUSTOMER_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_CUSTOMER_FAILURE, error };
  }
};

export const profileUpdate = (formData) => {
  return (dispatch) => {
    frontService.profileUpdate(formData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.UPDATE_PROFILE_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.UPDATE_PROFILE_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.UPDATE_PROFILE_FAILURE, error };
  }
};

export const changePassword = (formData) => {
  return (dispatch) => {
    frontService.changePassword(formData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.UPDATE_PASSWORD_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.UPDATE_PASSWORD_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.UPDATE_PASSWORD_FAILURE, error };
  }
};

export const printVoucher = (voucherID, type, lang) => {
  return (dispatch) => {
    frontService.printVoucher(voucherID, type, lang).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.PRINT_VOUCHER_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.PRINT_VOUCHER_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.PRINT_VOUCHER_FAILURE, error };
  }
};
export const printarchiveVoucher = (voucherID, type, lang) => {
  return (dispatch) => {
    frontService.printarchiveVoucher(voucherID, type, lang).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.PRINT_AVOUCHER_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.PRINT_AVOUCHER_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.PRINT_AVOUCHER_FAILURE, error };
  }
};

export const getSiteCity = (formData) => {
  return (dispatch) => {
    frontService.getSiteCity(formData).then(
      (data) => {
        dispatch(success(data));
      },

      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };
  function request(data) {
    return { type: frontConstants.GET_CITY_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_CITY_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_CITY_FAILURE, error };
  }
};

export const categoryWiseDeal = (postData) => {
  return (dispatch) => {
    frontService.categoryWiseDeal(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_CATDEAL_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_CATDEAL_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_CATDEAL_FAILURE, error };
  }
};

export const generateCoupon = (dealID) => {
  return (dispatch) => {
    frontService.generateCoupon(dealID).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_COUPON_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_COUPON_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_COUPON_FAILURE, error };
  }
};

export const storeCredit = () => {
  return (dispatch) => {
    frontService.storeCredit().then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_STORECREDIT_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_STORECREDIT_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_STORECREDIT_FAILURE, error };
  }
};

export const selectAttributes = (formData) => {
  return (dispatch) => {
    frontService.selectAttributes(formData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_SETATTRIBUTE_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_SETATTRIBUTE_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_SETATTRIBUTE_FAILURE, error };
  }
};

export const subscribeUser = (formData) => {
  return (dispatch) => {
    frontService.subscribeUser(formData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.POST_SUBSCRIBE_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.POST_SUBSCRIBE_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.POST_SUBSCRIBE_FAILURE, error };
  }
};

export const unsubscribeUser = (formData) => {
  return (dispatch) => {
    frontService.unsubscribeUser(formData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.POST_SUBSCRIBE_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.POST_SUBSCRIBE_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.POST_SUBSCRIBE_FAILURE, error };
  }
};

export const authenticateCityPassword = (formData) => {
  return (dispatch) => {
    frontService.authenticateCityPassword(formData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.POST_AUTH_CITY_PWD_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.POST_AUTH_CITY_PWD_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.POST_AUTH_CITY_PWD_FAILURE, error };
  }
};

export const checkUserDeal = () => {
  return (dispatch) => {
    frontService.checkUserDeal().then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };
  function request(data) {
    return { type: frontConstants.CHECK_USER_DEAL_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.CHECK_USER_DEAL_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.CHECK_USER_DEAL_FAILURE, error };
  }
};

export const becomePartner = (formData) => {
  return (dispatch) => {
    frontService.becomePartner(formData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.POST_PARTNER_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.POST_PARTNER_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.POST_PARTNER_FAILURE, error };
  }
};

export const partnerPermission = (url) => {
  return (dispatch) => {
    frontService.partnerPermission(url).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.PARTNER_PERMISSION_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.PARTNER_PERMISSION_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.PARTNER_PERMISSION_FAILURE, error };
  }
};

export const orderStatus = (postData) => {
  return (dispatch) => {
    frontService.orderStatus(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.POST_STATUS_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.POST_STATUS_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.POST_STATUS_FAILURE, error };
  }
};

export const deleteUser = (postData) => {
  return (dispatch) => {
    frontService.deleteUser(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };
  function request(data) {
    return { type: frontConstants.POST_STATUS_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.POST_STATUS_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.POST_STATUS_FAILURE, error };
  }
};

export const getcharityList = (postData) => {
  return (dispatch) => {
    frontService.getcharityList(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.POST_CHARITYLIST_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.POST_CHARITYLIST_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.POST_CHARITYLIST_FAILURE, error };
  }
};

export const removePromoCode = (postData) => {
  return (dispatch) => {
    frontService.removePromoCode(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.REMOVE_ROMO_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.REMOVE_ROMO_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.REMOVE_ROMO_FAILURE, error };
  }
};

export const voucherStatus = (postData) => {
  return (dispatch) => {
    frontService.voucherStatus(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.POST_STATUS_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.POST_STATUS_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.POST_STATUS_FAILURE, error };
  }
};

export const userCoupanList = (formData) => {
  return (dispatch) => {
    frontService.userVoucherList(formData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_COUPONLIST_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_COUPONLIST_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_COUPONLIST_FAILURE, error };
  }
};

export const getRefferals = (postData) => {
  return (dispatch) => {
    frontService.getRefferals(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_REFFERALS_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_REFFERALS_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_REFFERALS_FAILURE, error };
  }
};

export const delteCard = (postData) => {
  return (dispatch) => {
    frontService.delteCard(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.DELETE_CARD_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.DELETE_CARD_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.DELETE_CARD_FAILURE, error };
  }
};

export const getAllSiteCity = () => {
  return (dispatch) => {
    frontService.getAllSiteCity().then(
      (data) => {
        dispatch(success(data));
      },

      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };
  function request(data) {
    return { type: frontConstants.GET_ALLCITY_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_ALLCITY_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_ALLCITY_FAILURE, error };
  }
};

export const printSampleVoucher = (dealID) => {
  return (dispatch) => {
    frontService.printSampleVoucher(dealID).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.PRINT_VOUCHER_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.PRINT_VOUCHER_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.PRINT_VOUCHER_FAILURE, error };
  }
};

export const getLanguageList = (postData) => {
  return (dispatch) => {
    frontService.getLanguageList(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_LANGLIST_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_LANGLIST_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_LANGLIST_FAILURE, error };
  }
};

export const mailedOrderList = (formData) => {
  return (dispatch) => {
    frontService.mailedOrderList(formData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_MAILEDLIST_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_MAILEDLIST_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_MAILEDLIST_FAILURE, error };
  }
};

export const giftOrderList = (formData) => {
  return (dispatch) => {
    frontService.giftOrderList(formData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_GIFTLIST_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_GIFTLIST_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_GIFTLIST_FAILURE, error };
  }
};

export const generatedOrderList = (formData) => {
  return (dispatch) => {
    frontService.generatedOrderList(formData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_GENERATEDLIST_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_GENERATEDLIST_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_GENERATEDLIST_FAILURE, error };
  }
};

export const getSubscriberDetail = (subscriberID) => {
  return (dispatch) => {
    frontService.getSubscriberDetail(subscriberID).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_SUBSCRIBERDETAIL_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_SUBSCRIBERDETAIL_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_SUBSCRIBERDETAIL_FAILURE, error };
  }
};

export const updatesubscribeUser = (formData) => {
  return (dispatch) => {
    frontService.updatesubscribeUser(formData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.POST_SUBSCRIBE_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.POST_SUBSCRIBE_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.POST_SUBSCRIBE_FAILURE, error };
  }
};

export const taxRate = (postData) => {
  return (dispatch) => {
    frontService.taxRate(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(data) {
    return { type: frontConstants.GET_TAX_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_TAX_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_TAX_FAILURE, error };
  }
};

export const getSearchState = (postData) => {
  return (dispatch) => {
    frontService.getSearchState(postData).then(
      (data) => {
        dispatch(success(data));
      },

      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };
  function request(data) {
    return { type: frontConstants.GET_SEARCHSTATE_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.GET_SEARCHSTATE_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.GET_SEARCHSTATE_FAILURE, error };
  }
};

export const CheckGuestEmail = (postData) => {
  return (dispatch) => {
    frontService.CheckGuestEmail(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };
  function request(data) {
    return { type: frontConstants.CHECKGUESTEMAIL_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.CHECKGUESTEMAIL_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.CHECKGUESTEMAIL_FAILURE, error };
  }
};

export const RegGuestEmail = (postData) => {
  return (dispatch) => {
    frontService.RegGuestEmail(postData).then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };
  function request(data) {
    return { type: frontConstants.REGGUESTEMAIL_REQUEST, data };
  }
  function success(data) {
    return { type: frontConstants.REGGUESTEMAIL_SUCCESS, data };
  }
  function failure(error) {
    return { type: frontConstants.REGGUESTEMAIL_FAILURE, error };
  }
};

const siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
export const mapkey =
  !isEmpty(siteData) &&
  !isEmpty(siteData.api_settings) &&
  siteData.api_settings[0].google_map_key != ""
    ? siteData.api_settings[0].google_map_key
    : "";



// WEBPACK FOOTER //
// ./src/app/redux/actions/frontActions.js